// extracted by mini-css-extract-plugin
export default {"desc":"TenantDescription_desc__D+gn+"};